0<template>
  <div
    class="vid-int-videoTest__video-container"
    :class="{
      is_youtube,
      is_big,
      is_full_width,
      'is-rec': state === 'recording',
      'is-vresume': isVideoresume
    }"
    :style="{ width: width + 'px', height: height + 'px' }"
  >
    <div v-if="show_recorder">
      <video-recorder
        ref="video_recorder"
        :key="duration"
        :disabled="disabled"
        :disabled-recording-button="disabledRecordingButton"
        :action="action"
        :duration="duration"
        :is_big="is_big"
        :has_mask_on_video="has_mask_on_video"
        :upload-progress="uploadProgress"
        :bg_blue="bg_blue"
        :width="width"
        :height="height"
        :hide-mobile-btns="hideMobileBtns"
        :is-stream="streamRecord"
        :hide-btns="hideBtns"
        :is-videoresume="isVideoresume"
        :has-video="hasVideo"
        @setState="setState"
        @setRecorder="setRecorder"
        @start="startRecording"
        @stop="stopRecording"
        @complete="completeRecording"
      />
    </div>

    <div v-else-if="show_player">
      <div class="video-preview" :style="{ height: height + 'px', minHeight: height + 'px' }">
        <video-player
          v-if="src && !is_id_changed"
          ref="video_player"
          class="hiddenDuration hiddenLiveControl"
          :class="{ 'test-bar': test_question, 'is-mirror': !is_youtube }"
          :src="src"
          :is_youtube="is_youtube"
          :disabled="disabled"
          :not_editable="not_editable"
          :has_playback_rates="false"
          :is_playsinline="is_playsinline"
          :width="width"
          :height="height"
          :is-ios="isIos"
          :has-video="hasVideo"
          :is-mirror="isMirror"
          @error="player_error($event)"
          @videoPlayHandler="player_play"
          @videoPauseHandler="player_pause"
          @videoEndedHandler="player_end"
          @onPlayerWaiting="player_waiting"
          @onPlayerTimeupdate="onPlayerTimeupdate"
        />
        <div v-else-if="!is_id_changed" class="blocked-message">
          {{ $tr('admin_console.response.videointerview.blocked') }}
        </div>
        <div v-if="questionDuration && showQuestionDuration" class="video__duration">
          <span>{{ formatedTimeQuestionDuration }}</span>
        </div>
        <div v-if="defineRecordingFlow === 'default_ios' && hide_safari" class="safari-preview">
          <img src="/static/icons/vi_accept.png" alt="" />
          <div class="safari-preview__text">{{ $tr('videoInterview.checkVideo.accept') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import VideoRecorder from '@/components/VideoRecorder';
import VideoPlayer from '@/components/VideoPlayer';
import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js';

export default {
  name: 'Vrecorder',

  components: {
    VideoRecorder,
    VideoPlayer
  },

  mixins: [SafariBrowserDetector],

  props: {
    src: {
      type: String,
      default: ''
    },

    duration: {
      type: Number,
      default: 0
    },

    questionDuration: {
      type: Number,
      default: 0
    },

    showQuestionDuration: {
      type: Boolean,
      default: false
    },

    hideBtns: {
      type: Boolean,
      default: false
    },

    hasVideo: {
      type: Boolean,
      default: true
    },

    isFullScreen: {
      type: Boolean,
      default: false
    },

    isMirror: {
      type: Boolean,
      default: true
    },

    is_playsinline: {
      type: Boolean,
      default: false
    },

    streamRecord: {
      type: Boolean,
      default: false
    },

    isVideoresume: {
      type: Boolean,
      default: false
    },

    action: {
      type: String,
      default: ''
    },

    disabled: {
      type: Boolean,
      default: false
    },

    hideMobileBtns: {
      type: Boolean,
      default: false
    },

    disabledRecordingButton: {
      type: Boolean,
      default: false
    },

    not_editable: {
      type: Boolean,
      default: false
    },

    show_recorder: {
      type: Boolean,
      default: true
    },

    hide_safari: {
      type: Boolean,
      default: true
    },

    show_player: {
      type: Boolean,
      default: false
    },

    is_retake_video: {
      type: Boolean,
      default: false
    },

    uploadProgress: {
      type: Number,
      default: 0
    },

    is_youtube: {
      type: Boolean,
      default: false
    },

    bg_blue: {
      type: Boolean,
      default: false
    },

    is_big: {
      type: Boolean,
      default: false
    },

    has_mask_on_video: {
      type: Boolean,
      default: true
    },

    id: {
      type: String,
      default: '0'
    },

    is_full_width: {
      type: Boolean,
      default: false
    },

    test_question: {
      type: Boolean,
      default: false
    },

    width: {
      type: Number,
      default: 564
    },

    height: {
      type: Number,
      default: 375
    }
  },

  data() {
    return {
      is_id_changed: false,
      state: '',
      is_show: true
    };
  },

  computed: {
    formatedTimeQuestionDuration() {
      if (!this.questionDuration) {
        return 0;
      }
      return moment.duration(this.questionDuration / 1000, 'seconds').format('mm:ss', { trim: false });
    }
  },

  watch: {
    id() {
      this.is_id_changed = true;

      setTimeout(() => {
        this.is_id_changed = false;
      }, 1000);
    }
  },

  methods: {
    startRecording() {
      this.$emit('startRecording');
    },

    stopRecording() {
      this.$emit('stopRecording');
    },

    completeRecording(data) {
      this.$emit('completeRecording', data);
    },

    retakeTestVideo(val) {
      this.$emit('retakeTestVideo', val);
    },

    player_error(ev) {
      this.$emit('player_error', ev);
    },

    player_play(ev) {
      this.$emit('player_play', ev);
    },

    player_pause(ev) {
      this.$emit('player_pause', ev);
    },

    player_end(ev) {
      this.$emit('player_end', ev);
    },

    onPlayerTimeupdate(ev) {
      this.$emit('onPlayerTimeupdate', ev);
    },

    player_waiting(ev) {
      this.$emit('player_waiting', ev);
    },

    setState(v) {
      this.state = v;
      this.$emit('setState', v);
    },

    setRecorder(v) {
      this.$emit('setRecorder', v);
    }
  }
};
</script>

<style lang="scss" scoped>
.vid-int-videoTest__video-container {
  position: relative;
  background-color: #fff;

  &.is_full_width {
    width: 100%;
    border: 0;
    margin-bottom: 0;
  }
}

.vid-init-videoTest__rerecord-button {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #000;
  margin-bottom: 30px;
}

.video-preview {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #000;

  @media only screen and (max-width: 960px) {
    height: auto !important;
  }

  @media only screen and (max-width: 480px) {
    min-height: 192px !important;
  }
}
.is-rec {
  .video-preview {
    @media only screen and (max-width: 480px) {
      max-height: 100% !important;
      min-height: 100% !important;
    }
  }
}
.is_full_width {
  .video-preview {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: #000;
  }
}
.safari-preview {
  position: absolute;
  left: 0;
  right: 0;
  height: calc(100% + 1px);
  width: 100%;
  background: #f2f8f1;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__text {
    margin-top: 10px;
    font-size: 14px;
  }
}

.blocked-message {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  background: #f2f8f1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.video__duration {
  position: absolute;
  top: 16px;
  left: 16px;
  padding: 8px 15px;
  background: rgba(244, 245, 247, 0.5);
  color: #607183;
  font-size: 15px;
  font-weight: bold;
  z-index: 4;
  line-height: 22px;
  border-radius: 2px;
  text-align: center;
  display: flex;
  align-items: center;

  &-active {
    color: $red;
    padding: 8px 13px 9px 11px;
  }

  span {
    position: relative;
  }
}

.is-vresume {
  .video__duration {
    background: #f4f5f7;
    border-radius: 2px;
    color: #8d8d8d;
  }
}

.question_video {
  max-width: 100%;
}
</style>
